module.exports = __webpack_public_path__ + "history-round.f940f622e7bb0d1650fe.png";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/history-round.png
// module id = ../../../../../src/img/history-round.png
// module chunks = styles